<template>
  <div id="dapin" class="contents"
    :style="{ backgroundImage:`url(${homeconfig.big_background_url?homeconfig.big_background_url:'require(../../../assets/images/ktscreen/defalutbc.png)'})`}">
    <!-- 首页 -->
    <div v-if="homeconfig.type==1">
      <img class="headerimg" :src="homeconfig.logo_url" alt="" />
      <div class="info_container">
        <div class="title1">智慧党建+{{homeconfig.first_title}}</div>
        <img class="title2" :src="homeconfig.title_logo_url" alt="" srcset="" />
        <div class="infobox">
          <p>{{homeconfig.second_title}}</p>
          <div v-html="homeconfig.content">
          </div>
        </div>
      </div>
      <div class="btnbox" @click="gopath">
        <img v-if="homeconfig.btn_cover" class="btncover" :src="homeconfig.btn_cover" alt="" srcset="">
        进入数据大屏
      </div>
    </div>
    <div class="otherlogin" v-if="homeconfig.type==2||defaultconfig">
      <div class="btnbox2" @click="gopath">
        进入数据大屏
      </div>
    </div>
    <!-- 弹窗 -->
    <WDialog :isshow="isshowpop" :datas="datas" @changepop="changepop"></WDialog>
  </div>
</template>
<script>
  import { pageResize } from "@/assets/js/resetScreenSize";
  import {
    gethomepagebysignapi
  } from "@/network/api/platformghome.js";
  import WDialog from "../../../views/Works/platformHome/components/WDialog"
  export default {
    components: {
      WDialog
    },
    data() {
      return {
        homeconfig: {},
        isshowpop: false,
        datas: {
          colortype: 4
        },
        defaultconfig: true,
      };
    },
    methods: {
      topath(url) {
        this.$router.push(url);
      },
      async getinfo(url) {
        let datas = await gethomepagebysignapi({ 'private_sign': url });
        if (datas.data.res) {
          this.defaultconfig = false;
          this.homeconfig = datas.data.res
          this.datas.logintitle = datas.data.res.screen_general_title
        }
      },
      //弹窗回调
      changepop() {
        this.isshowpop = false;
      },
      //跳转
      gopath() {
        this.$router.push({ name: 'Team' })
      }
    },
    mounted() {
      pageResize();
    },
    created() {
      var private_sign = this.$route.query.private_sign;
      if (private_sign) {
        this.getinfo(private_sign);
      }
    }
  };
</script>
<style lang="less" scoped>
  .contents {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    line-height: 1;
    background-image: url("../../../assets/images/ktscreen/defalutbc.png");
  }

  .bcbox {
    width: 100%;
    height: 100%;
  }

  .headerimg {
    width: 5rem;
    padding-left: 1%;
    padding-top: 0.5%;
  }

  .title1 {
    font-size: 0.5rem;
    letter-spacing: 10px;
    font-weight: 800;
    text-align: center;
    color: red;
  }

  .title2 {
    padding-top: 0.3rem;
    width: 15rem;
    margin: auto;
  }

  .info_container {
    width: 80%;
    margin: auto;
    text-align: center;
  }

  .infobox {
    padding: 0 8%;
    line-height: 1.8;
    font-size: 0.26rem;

    p {
      text-align: center;
      font-size: 0.4rem;
      padding: 0.1rem 0;
      font-weight: bold;
    }

    div {
      height: 3.5rem;
      overflow: hidden;
      font-size: 0.25rem;
    }
  }

  .goinbtn {
    display: inline-block;
    background-color: red;
    font-size: 18px;
    padding: 12px 25px;
    border-radius: 45px;
    cursor: pointer;

    span {
      color: #fff;
      font-weight: bold;
      letter-spacing: 2px;
    }
  }

  .goinicon {
    height: 30px;
    vertical-align: middle;
  }

  .btnbox {
    cursor: pointer;
    display: inline-block;
    width: 2rem;
    background-color: red;
    color: #fff;
    height: 0.7rem;
    line-height: 0.7rem;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 0.8rem;
    font-size: 0.25rem;
    position: relative;
  }

  .btnbox2 {
    cursor: pointer;
    display: inline-block;
    width: 1.5rem;
    color: #efd090;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    position: absolute;
    right: 5%;
    top: 2%;
    font-size: 0.2rem;
    border: 2px solid #efd090;
  }

  .btncover {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
  }
</style>



// WEBPACK FOOTER //
// src/views/Works/platformHome/index.vue